import { modalActions } from './actions';

export const modalIntialState = {
    isOpen: false,
    modalDataKey: ['platformAdmin', 'status'],
    modalAction: '',
    modalCancelAction: '',
    data: {},
    modalVariant: 'none',
    currentModalId: null,
    modalList: [],
};

export const ModalReducer = (state = modalIntialState, action) => {
    switch (action.type) {
        case modalActions.OPEN_MODAL:
            if (!action?.payload?.currentModalId) action.payload.currentModalId = 0;
            let modalListUpdatedData = [];
            let modalListData = {
                isOpen: true,
                modalDataKey: action.payload.modalDataKey,
                modalAction: action.payload.modalAction,
                modalCancelAction: action.payload.modalCancelAction,
                isVisible: true,
                data: action.payload.data,
                modalColor: action.payload.modalVariant,
                currentModalId: action.payload.currentModalId,
            };
            if (action?.payload?.hasChildModal) {
                modalListUpdatedData = state?.modalList;
                if (!modalListUpdatedData?.find((f) => f.currentModalId === modalListData.currentModalId))
                    modalListUpdatedData.push(modalListData);
            } else {
                modalListUpdatedData = [{ ...modalListData }];
            }
            return {
                ...state,
                isOpen: true,
                modalDataKey: action.payload.modalDataKey,
                modalAction: action.payload.modalAction,
                modalCancelAction: action.payload.modalCancelAction,
                isVisible: true,
                data: action.payload.data,
                modalColor: action.payload.modalVariant,
                currentModalId: action.payload.currentModalId,
                modalList: modalListUpdatedData,
            };
        case modalActions.CLOSE_MODAL:
            if (state?.modalList?.length > 1) {
                //let currentModalId = state?.currentModalId;
                let modalListData = state?.modalList;
                modalListData.splice(-1);
                let lastItem = modalListData[modalListData?.length - 1];
                lastItem.modalList = modalListData;
                return {
                    ...state,
                    isOpen: true,
                    ...lastItem,
                };
            } else {
                return {
                    ...state,
                    isOpen: false,
                    currentModalId: null,
                    modalList: [],
                };
            }
        case modalActions.CLOSE_ALL_EXCEPT_INITIATOR_MODAL:
            return {
                ...state,
                isOpen: false,
                currentModalId: null,
                modalList: [],
            };
        // if (state?.modalList?.length > 1) {
        //     let modalListData = state?.modalList;
        //     let lastItem = modalListData[0];
        //     lastItem.modalList = [lastItem];
        //     return {
        //         ...state,
        //         isOpen: true,
        //         ...lastItem,
        //     };
        // } else {
        //     return {
        //         ...state,
        //         isOpen: false,
        //         currentModalId: null,
        //         modalList: [],
        //     };
        // }

        default:
            throw new Error();
    }
};
